import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const PIEZAS_API = {
  new: async (pieza) => {
    return API.post('/piezas', pieza, pieza instanceof FormData ? headers : null).then(res => res.data);
  },
  update: async (pieza) => {
    return API.post('/piezas/' + pieza.id, pieza, pieza instanceof FormData ? headers : null).then(res => res.data);
  },
  saveImages: async (images) => {
    return API.post('/piezas/images/save', images, headers).then(res => res.data);
  },
  removeImagesBG: async (images) => {
    return API.post('/piezas/images/remove-bg', images, headers).then(res => res.data);
  },
  updatePagoProveedor: async (piezaId, pieza) => {
    return API.put('/piezas/' + piezaId + '/pago-proveedor', pieza).then(res => res.data);
  },
  delete: async (idPieza) => {
    return API.delete('/piezas/' + idPieza).then(res => res.data);
  }
}

export const INTEGRACIONES_API = {
  getMarcas: async () => {
    return await API.get('/integracion/makers').then((res)=> { return JSON.parse(res.data.data) });
  },
  getModelos: async (marca_id, marca_mb_id) => {
    return await API.get(`/integracion/modelos?marca_id=${marca_id}&marca_mb_id=${marca_mb_id}`)
      .then((res)=> { return JSON.parse(res.data.data) });
  },
  getTipoPiezas: async () => {
    return await API.get(`/integracion/nombres`).then((res)=> { return JSON.parse(res.data.data) });
  },
  getPiezas: async (search, page = null) => {
      const pagination = page !== null ? '&page=' + page : '';
      let query = Object.keys(search).filter((key) => search[key] !== null && search[key] !== "" && search[key] !== 0 && search[key] !== "0")
        .map((key, i) => { return i === 0 ? '?' + key + '=' + search[key] : '&' + key + '=' + search[key]; })
      query = query.join("");

      return await API.get(`/integracion/stock` + query + pagination).then((res)=> {
        return res.data
      });
  },
  markProblemAsRead: async(problemaId) => {
    return API.post('/integracion/' + problemaId + '/leido', {}).then(res => res.data);
  },
  soldConfirm: async (ventaId, proveedorId, confirmacion, piezaId) => {
    return API.post('/integracion/' + ventaId + '/confirmacion/' + proveedorId, {confirmacion, piezaId}).then(res => res.data);
  },
  getStatus: async (refresh) => {
    return await API.get('/integracion/status?refresh=' + refresh).then((res)=> res.data);
  }
}

export const REMOVE_BG_IMGS = {
  removeBg: async(imgsUrl) => {
    return API.post('remove-background-images', { imgsUrl }).then(res => res.data);
  },
}